import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Directive, forwardRef, Type } from '@angular/core';

@Directive({
  selector: '[tdWbPhoneNumberValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<PhoneNumberValidatorDirective> => PhoneNumberValidatorDirective),
    multi: true
  }]

})
export class PhoneNumberValidatorDirective implements Validator {

  // eslint-disable-next-line @typescript-eslint/typedef
  private validAreaCodes = [368, 403, 587, 780, 825, 604, 250, 778, 236, 672, 204, 431, 584, 506, 709, 867, 782, 902, 867, 705, 365, 548, 613, 807, 226, 289, 437, 647, 905, 249, 343, 416, 519, 902, 782, 418, 450, 579, 873, 367, 581, 819, 514, 438, 639, 306, 867, 474, 428, 879, 683, 382, 742, 753, 263, 354, 468];

  validate(control: AbstractControl): ValidationErrors | null {
    return this.isValid(control.value) ? null : { invalidPhoneNumber: true };
  }

  isValid(strPhoneNumber: string): boolean {
    let isValid = true;
    let parsedNumber;

    if (strPhoneNumber) {
      try {
        parsedNumber = String(strPhoneNumber).replace(/\D+/g, '');

        // first check for 10 numbers
        if (parsedNumber.length !== 10) {
          isValid = false;
        } else {
          // validate area code
          return this.validAreaCodes.some(
            (anAreaCode: number) => anAreaCode.toString() === parsedNumber.substring(0, 3));
        }

      } catch (ex) {
        // in case exception was thrown by parse function
        isValid = false;
        // eslint-disable-next-line no-console
        console.log(ex);
      }
    }

    return isValid;
  }
}
